var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayFilledIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59761 12.5938C6.47769 12.5936 6.3599 12.5621 6.25581 12.5026C6.02144 12.3698 5.87573 12.1119 5.87573 11.8321V6.168C5.87573 5.88734 6.02144 5.63031 6.25581 5.4975C6.36237 5.43625 6.48343 5.40476 6.60633 5.4063C6.72923 5.40785 6.84945 5.44238 6.95444 5.50628L11.7953 8.40394C11.8962 8.4672 11.9793 8.55505 12.037 8.65924C12.0946 8.76344 12.1249 8.88056 12.1249 8.99964C12.1249 9.11872 12.0946 9.23585 12.037 9.34005C11.9793 9.44424 11.8962 9.53209 11.7953 9.59535L6.95366 12.4938C6.84622 12.5587 6.72316 12.5933 6.59761 12.5938Z",
    fill: "#01353B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFilledIcon);
export default __webpack_public_path__ + "static/media/play-filled-icon.077033248eeb931dfef20494291c8489.svg";
export { ForwardRef as ReactComponent };